import cloneDeep from 'lodash/cloneDeep';

export default class ContactList {
  name;
  createTime;

  constructor(data) {
    Object.assign(this, cloneDeep(data));
  }

  includes(searchString) {
    return this.name.toLowerCase().includes((searchString || '').toLowerCase());
  }

  static compare(listA, listB) {
    const comparableFieldsA = [listA.name].join('').toLowerCase();
    const comparableFieldsB = [listB.name].join('').toLowerCase();

    if (comparableFieldsA < comparableFieldsB) {
      return -1;
    }
    if (comparableFieldsA > comparableFieldsB) {
      return 1;
    }
    return 0;
  }
}
